// ================================================================
//  confirmAndDelete — shared delete flow for every master screen
//
//  • Asks for confirmation (shows the record name)
//  • Runs the delete
//  • Turns Postgres "still referenced" errors (23503) into a
//    friendly message instead of failing silently
//
//  Usage:
//    await confirmAndDelete({
//      what: "area", name: area.area_name,
//      usedIn: "clients",
//      run: () => deleteArea(area.area_id),
//    });
// ================================================================

const PG_FOREIGN_KEY_VIOLATION = "23503";

export async function confirmAndDelete({ what, name, usedIn = "other records", run }) {
    const label = name ? `${what} "${name}"` : `this ${what}`;
    if (!window.confirm(`Delete ${label}?\n\nThis cannot be undone.`)) return false;

    try {
        await run();
        return true;
    } catch (err) {
        console.error("Delete failed", err);
        if (err?.code === PG_FOREIGN_KEY_VIOLATION) {
            alert(`Cannot delete ${label} because it is used in ${usedIn}.`);
        } else {
            alert("Delete failed: " + (err?.message || "Unknown error"));
        }
        return false;
    }
}
